import { createClient } from '@supabase/supabase-js'
import type { Database } from './types/supabase'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Note: we keep runtime schema selection, but intentionally relax TypeScript
// typing of the Supabase client to avoid verbose generic result types in all
// callers. Call sites use their own well-defined interfaces (RaceStats, etc.).
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    db: {
      // Use skistat_db as the default PostgREST schema for this client
      schema: 'skistat_db' as any, // keep runtime value, bypass `"public"` type constraint
    },
  } as any, // relax options typing to keep `supabase` effectively `any` for callers
) as any;
